module.exports = __webpack_public_path__ + "static/media/hakusteel-4.2a9638e8.png";